import { ReactNode } from "react";
import "./TeamProfile.css";

export interface TeamProfileProps {
    teamName: string;
    teamDescription: ReactNode;
    teamImagePath: string;
    officer1?: ReactNode;
    officer2?: ReactNode;
}

const TeamProfile = ({ teamName, teamDescription, teamImagePath, officer1, officer2 }: TeamProfileProps) => {
    return (
        <div className="team-profile">
            <div className="team-profile-info">
                <h1 className="team-profile-name">{teamName}</h1>
                <img src={teamImagePath} alt={`${teamName} team`} className="team-profile-photo" />
                <div className="team-profile-description">{teamDescription}</div>
            </div>
            <div className="team-profile-officers">
                {officer1}
                {officer2}
            </div>
        </div>
    );
};

export default TeamProfile;
